define('lq/javascript/polyfill',[], function () {

    // source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf?redirectlocale=en-US&redirectslug=JavaScript%2FReference%2FGlobal_Objects%2FArray%2FindexOf#Compatibility
    if (!Array.prototype.indexOf) {
        Array.prototype.indexOf = function (searchElement, fromIndex) {
            var i,
                pivot = (fromIndex) ? fromIndex : 0,
                length;

            if (!this) {
                throw new TypeError();
            }

            length = this.length;

            if (length === 0 || pivot >= length) {
                return -1;
            }

            if (pivot < 0) {
                pivot = length - Math.abs(pivot);
            }

            for (i = pivot; i < length; i++) {
                if (this[i] === searchElement) {
                    return i;
                }
            }
            return -1;
        };
    }

    // From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
    if (!Object.keys) {
        Object.keys = (function () {
            'use strict';
            var hasOwnProperty = Object.prototype.hasOwnProperty,
                hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
                dontEnums = [
                  'toString',
                  'toLocaleString',
                  'valueOf',
                  'hasOwnProperty',
                  'isPrototypeOf',
                  'propertyIsEnumerable',
                  'constructor'
                ],
                dontEnumsLength = dontEnums.length;

            return function (obj) {
                if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
                    throw new TypeError('Object.keys called on non-object');
                }

                var result = [], prop, i;

                for (prop in obj) {
                    if (hasOwnProperty.call(obj, prop)) {
                        result.push(prop);
                    }
                }

                if (hasDontEnumBug) {
                    for (i = 0; i < dontEnumsLength; i++) {
                        if (hasOwnProperty.call(obj, dontEnums[i])) {
                            result.push(dontEnums[i]);
                        }
                    }
                }
                return result;
            };
        }());
    }

    // textContent support based on innerText for IE8
    // from: https://gist.github.com/joshrhoades/8874249
    if (Object.defineProperty && Object.getOwnPropertyDescriptor && Object.getOwnPropertyDescriptor(Element.prototype, "textContent") && !Object.getOwnPropertyDescriptor(Element.prototype, "textContent").get) {
        (function () {
            var innerText = Object.getOwnPropertyDescriptor(Element.prototype, "innerText");
            Object.defineProperty(Element.prototype, "textContent",
                {
                    get: function () {
                        return innerText.get.call(this);
                    },
                    set: function (s) {
                        return innerText.set.call(this, s);
                    }
                }
            );
        })();
    }

    // CustomEvent for IE
    // from: https://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
    if ( typeof window.CustomEvent !== "function" ) {
        function CustomEvent ( event, params ) {
            params = params || { bubbles: false, cancelable: false, detail: undefined };
            var evt = document.createEvent( 'CustomEvent' );
            evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
            return evt;
        }
        CustomEvent.prototype = window.Event.prototype;
        window.CustomEvent = CustomEvent;
    }

	/*
	 * Pointer Events Polyfill: Adds support for the style attribute "pointer-events: none" to browsers without this feature (namely, IE).
	 * (c) 2013, Kent Mewhort, licensed under BSD.
	 */

	/* @license
	 * BSD License for Pointer Events Polyfill (http://github.com/kmewhort/pointer_events_polyfill)
	 *
	 * Copyright (c) 2013, Kent Mewhort
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that the
	 * following conditions are met:
	 *
	 *     Redistributions of source code must retain the above copyright notice, this list of conditions and the following
	 *     disclaimer.
	 *     Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following
	 *     disclaimer in the documentation and/or other materials provided with the distribution.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES,
	 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
	 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
	 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 * WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
	 * THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */

	// constructor
    function PointerEventsPolyfill(options) {
    	// set defaults
    	this.options = {
    		selector: '*',
    		mouseEvents: ['click', 'dblclick', 'mousedown', 'mouseup'],
    		usePolyfillIf: function () {
    			if (navigator.appName == 'Microsoft Internet Explorer') {
    				var agent = navigator.userAgent;
    				if (agent.match(/MSIE ([0-9]{1,}[\.0-9]{0,})/) != null) {
    					var version = parseFloat(RegExp.$1);
    					if (version < 11)
    						return true;
    				}
    			}
    			return false;
    		}
    	};
    	if (options) {
    		var obj = this;
    		$.each(options, function (k, v) {
    			obj.options[k] = v;
    		});
    	}

    	if (this.options.usePolyfillIf())
    		this.register_mouse_events();
    }

	// singleton initializer
    PointerEventsPolyfill.initialize = function (options) {
    	if (PointerEventsPolyfill.singleton == null)
    		PointerEventsPolyfill.singleton = new PointerEventsPolyfill(options);
    	return PointerEventsPolyfill.singleton;
    };

	// handle mouse events w/ support for pointer-events: none
    PointerEventsPolyfill.prototype.register_mouse_events = function () {
    	// register on all elements (and all future elements) matching the selector
    	$(document).on(this.options.mouseEvents.join(" "), this.options.selector, function (e) {
    		if (this != e.target)
    			return;
    		if ($(e.target).css('pointer-events') == 'none') {
    			// peak at the element below
    			var origDisplayAttribute = $(this).css('display');
    			$(this).css('display', 'none');

    			var underneathElem = document.elementFromPoint(e.clientX, e.clientY);

    			if (origDisplayAttribute)
    				$(this)
						.css('display', origDisplayAttribute);
    			else
    				$(this).css('display', '');

    			// fire the mouse event on the element below
    			e.target = underneathElem;
    			$(underneathElem).trigger(e);

    			return false;
    		}
    		return true;
    	});
    };

    window.PointerEventsPolyfill = PointerEventsPolyfill;

});
